import React, { createContext, useState, useContext } from "react";
import { GlobalContext } from "./GlobalState";

export const AccountSettingsState = createContext();

//--------------------------------------
export const AccountSettingsContext = ({ children }) => {
  const data = useContext(GlobalContext);

  const [firstName, setFirstName] = useState(data.userData.firstName);
  const [lastName, setLastName] = useState(data.userData.lastName);
  const [emailAddress, setEmailAddress] = useState(data.userData.emailAddress);
  const [currentWorkspace, setCurrentWorkspace] = useState(
    data.currentWorkspace
  );
  const [workspaces, setWorkspaces] = useState(
    data.workspaces ? data.workspaces : null
  );
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  return (
    <AccountSettingsState.Provider
      value={{
        firstName,
        setFirstName,
        lastName,
        setLastName,
        emailAddress,
        setEmailAddress,
        currentWorkspace,
        setCurrentWorkspace,
        workspaces,
        setWorkspaces,
        oldPassword,
        setOldPassword,
        newPassword,
        setNewPassword,
      }}
    >
      {children}
    </AccountSettingsState.Provider>
  );
};
